import { ROWS_PER_PAGE_OPTIONS } from './TablePagination.constants'
import { DEFAULT_NAMESPACE } from 'config/i18n'
import { useTranslation } from 'react-i18next'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import FirstPageOutlinedIcon from '@material-ui/icons/FirstPageOutlined'
import LastPageOutlinedIcon from '@material-ui/icons/LastPageOutlined'
import { TablePaginationProps } from './TablePagination.types'

export const usePagination = ({
  setPage,
  pageSize,
  page,
  totalRowsCount,
  sizes,
}: TablePaginationProps) => {
  const { t } = useTranslation(DEFAULT_NAMESPACE)
  const lastPageNumber = Math.ceil(totalRowsCount / pageSize)

  const options = (sizes || ROWS_PER_PAGE_OPTIONS).map(item => ({
    title: item,
    value: item,
  }))

  const paginationInfoString = t('of', {
    min: `${(page - 1) * pageSize + 1}`,
    max: `${
      page * pageSize > totalRowsCount ? totalRowsCount : page * pageSize
    } `,
    all: `${totalRowsCount}`,
  })

  const canSetPage = (potentialPage: number) =>
    potentialPage <= lastPageNumber && potentialPage >= 1

  const PaginationIconButtons = [
    {
      Icon: FirstPageOutlinedIcon,
      onClick: () => setPage(1),
      isDisabled: !canSetPage(page - 1),
      id: 'first-page',
    },
    {
      Icon: ChevronLeftIcon,
      onClick: () => setPage(page - 1),
      isDisabled: !canSetPage(page - 1),
      id: 'prev-page',
    },
    {
      Icon: ChevronRightIcon,
      onClick: () => setPage(page + 1),
      isDisabled: !canSetPage(page + 1),
      id: 'next-page',
    },
    {
      Icon: LastPageOutlinedIcon,
      onClick: () => setPage(lastPageNumber),
      isDisabled: !canSetPage(page + 1),
      id: 'last-page',
    },
  ]

  return {
    pageSize,
    paginationInfoString,
    options,
    PaginationIconButtons,
  }
}
